import { FCC } from "@/types/common";
import { Typography, Stack, styled, Tooltip, Box } from "@mui/material";
import { EMPTY_STR } from "@/constants/string";
import Divider from "@mui/material/Divider";
import { black, secondary, text } from "@/theme/colors";
import { IconCopyEmail } from "@/assets/icons/IconCopyEmail";
import { useState } from "react";

type TTalentInfoItem = {
  label?: string;
  value?: string | null | undefined;
  copyValue?: string | null | undefined;
  direction?: "row" | "column";
  isShowDivider?: boolean;
  isShowIconCopy?: boolean;
};

export const TalentInfoItem: FCC<TTalentInfoItem> = ({
  label,
  value,
  copyValue,
  direction,
  isShowDivider = true,
  isShowIconCopy = false,
  children,
}) => {
  const [messageTooltip, setMessageTooltip] = useState<string>("メールアドレスをコピー");

  const handleCopy = () => {
    const textToCopy = copyValue || value;
    if (!textToCopy) return;

    navigator.clipboard.writeText(textToCopy).then(() => {
      setMessageTooltip("メールアドレスをコピーしました。");
      setTimeout(() => {
        setMessageTooltip("メールアドレスをコピー");
      }, 2000);
    });
  };

  return (
    <>
      <TalentInfoItemWrapper direction={direction} gap={1}>
        {label && (
          <Typography variant="cap12" color={black[70]}>
            {label}
          </Typography>
        )}
        <ValueWrapper direction="row" justifyContent="space-between" gap={1}>
          <Typography
            variant="body14Semi"
            color={isShowIconCopy ? secondary[80] : text.primary}
            sx={{
              wordBreak: "break-word",
              overflowWrap: "break-word",
              flex: 1,
              minWidth: 0,
            }}
          >
            {value ? value : EMPTY_STR.TEXT}
          </Typography>
          {isShowIconCopy && (
            <Tooltip title={messageTooltip}>
              <IconWrapper
                onClick={handleCopy}
                sx={{
                  cursor: copyValue || value ? "pointer" : "not-allowed",
                }}
              >
                <IconCopyEmail />
              </IconWrapper>
            </Tooltip>
          )}
        </ValueWrapper>
        {children && <CustomContentWrapper>{children}</CustomContentWrapper>}
        {isShowDivider && <DividerWrapper />}
      </TalentInfoItemWrapper>
    </>
  );
};

const TalentInfoItemWrapper = styled(Stack)<{ direction?: string }>`
  ${({ direction }) => (direction === "row" ? `align-items: center;` : ``)}
`;

const ValueWrapper = styled(Stack)`
  align-items: flex-start;
`;

const IconWrapper = styled(Stack)`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const DividerWrapper = styled(Divider)`
  margin: 8px 0;
  width: 100%;
`;

const CustomContentWrapper = styled(Box)`
  margin-top: 4px;
`;
